import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Menu, Container, Grid, Dropdown } from 'semantic-ui-react';
import { Route, Switch, Link } from 'react-router-dom';
import _ from 'underscore';

import HradminDashboardPage from './dashboard_page';
import HradminEmployeeListPage from './employee_list_page';
import HradminEmployeeViewPage from './employee_view_page';
import { 
    doLogout,
    getHradminMhcInsightsURL,
} from '../../actions';

class HradminIndexPage extends Component {
    state = {
        activeItem: 'dashboard'
    }
    componentDidMount() {
        if (this.props.user && !this.props.user.accessToken) {
            this.props.history.push('/');
        }
        const assignedRoles = this.props.user.roles;
        if (!assignedRoles) {
            this.props.history.push('/');
        }
        const hasHrAdminRole = _.find(assignedRoles, (role) => role.type === 'hradmin');
        if (!hasHrAdminRole) {
            this.props.history.push('/');
        }
        // load mhc insights url
        const {accessToken} = this.props.user;
        this.props.getHradminMhcInsightsURL({accessToken});
    }
    handleItemClick = (event, values) => {
        this.setState({activeItem: values.name});
        if (values.name === 'logout') {
            this.props.doLogout();
            this.props.history.push('/');
        } else if (values.name === 'analytics') {
            console.log('clicked');
            window.open(this.props.mhcInsightsUrl, '_blank');
        } else {
            const BASE_URL = '/hradmin';
            const menuToUrl = {
                'dashboard': `${BASE_URL}`,
                // 'add client': `${BASE_URL}/addclient`,
                // 'users': `${BASE_URL}/users`,
                // 'system accounts': `${BASE_URL}/systemaccounts`,
                // 'add user': `${BASE_URL}/adduser`,
            }
            this.props.history.push(menuToUrl[values.name]);
        }
    }
    render() {
        const {activeItem} = this.state;
        return (
            <div>
                <Menu inverted>
                    <Container>
                        <Menu.Item 
                            name='dashboard' 
                            active={activeItem === 'dashboard'} 
                            onClick={this.handleItemClick} 
                        />
                        <Dropdown item text="Employee">
                            <Dropdown.Menu>
                                <Link to="/hradmin/employees">
                                    <Dropdown.Item style={{color: '#000'}}>
                                        View / Search Employees
                                    </Dropdown.Item>
                                </Link>
                                {/* <Link to="/hradmin/employee/add">
                                    <Dropdown.Item style={{color: '#000'}}>
                                        Add New Employee
                                    </Dropdown.Item>
                                </Link> */}
                            </Dropdown.Menu>
                        </Dropdown>
                        <Menu.Item
                            name='analytics'
                            disabled={(!this.props.mhcInsightsUrl) ? true : false}
                            active={activeItem === 'analytics'}
                            onClick={this.handleItemClick}
                        />
                        <Menu.Item
                            name='logout'
                            active={activeItem === 'logout'}
                            onClick={this.handleItemClick}
                        />
                    </Container>
                </Menu>
                <Switch>
                    <Route exact path="/hradmin" component={HradminDashboardPage} />
                    <Route exact path="/hradmin/employees" component={HradminEmployeeListPage} />
                    <Route path="/hradmin/employees/:uuid" component={HradminEmployeeViewPage} />
                </Switch>
                <Grid>
                    <Grid.Column>
                        
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return { 
        user: state.user.user,
        mhcInsightsUrl: state.hradmin.mhcInsightsUrl,
    };
}

export default connect(mapStateToProps, {
    doLogout,
    getHradminMhcInsightsURL,
})(HradminIndexPage);